<template>
  <div class="detail-header-wrap">
    <div class="apply-detail-top">
      <div class="detail-top-left">
        <i class="iconfont" :class="data.icon"></i>
      </div>
      <div class="detail-top-right">
        <h4 class="apply-detail-top__title">{{data.name}}</h4>
        <p class="apply-detail-top__text"><span>申请编号：{{data.invoice_no}}</span><span>申请日期：{{data.apply_time}}</span></p>
        <p class="apply-detail-top__text">{{data.text}}<span>{{data.cust_name}}</span></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    data: Object
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.apply-detail-top {
  display: flex;
  align-items: flex-start;
  padding: 23px 30px;
  margin-bottom: 10px;
  color: $fontBlack;
  &__title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
    color: $black;
  }
  &__text {
    font-size: 12px;
    & + & {
      margin-top: 10px;
    }
  }
}
.detail-top-left {
  & .iconfont {
    position: relative;
    font-size: 20px;
    top: -3px;
    margin-right: 12px;
  }
}
.detail-top-right {
  .apply-detail-top__text {
    & > span {
      margin-right: 20px;
    }
  }
}
.iconshenhezhong {
  color: $iconOrange;
}
.iconshanchu1 {
  color: $red;
}
.iconshenhetongguo {
  color: $green;
}
</style>
